import { PcRestartResponse } from '@acorn-portal/shared/src/services/subscriptionAPI';
import { Address } from '@acorn-portal/shared/src/services/subscriptionAPI';
import { IOptions } from '@acorn-portal/shared/src/components/inputs/select';
import getClosestMileage from '@acorn-portal/shared/src/utils/getClosestMileage';
import hasOverNightAddress from '@acorn-portal/shared/src/utils/has-overnight-address';

export interface IFormChangeAddress {
	isHomeOwner: string;
	address: Address;
	annualMileage: string;
	businessMileage: string;
	keptOvernight: string;
	overnightAddress: Address;
	overnightAddressIsAway: string;
}

export const getAddressInitialValues = (
	quoteData: PcRestartResponse | undefined,
	annualMileageOptions: IOptions[],
): IFormChangeAddress => ({
	isHomeOwner: quoteData?.quoteDetails.riskData.proposerDetails?.person?.isHomeOwner ? 'yes' : 'no',
	address: {
		line1: quoteData?.quoteDetails.riskData.proposerDetails?.address?.line1 ?? '',
		line2: quoteData?.quoteDetails.riskData.proposerDetails?.address?.line2 ?? '',
		line3: quoteData?.quoteDetails.riskData.proposerDetails?.address?.line3 ?? '',
		line4: quoteData?.quoteDetails.riskData.proposerDetails?.address?.line4 ?? '',
		city: quoteData?.quoteDetails.riskData.proposerDetails?.address?.city ?? '',
		county: quoteData?.quoteDetails.riskData.proposerDetails?.address?.county ?? '',
		country: quoteData?.quoteDetails.riskData.proposerDetails?.address?.country ?? '',
		postcode: quoteData?.quoteDetails.riskData.proposerDetails?.address?.postcode ?? '',
	},
	overnightAddress: {
		...(quoteData?.quoteDetails.riskData.vehicleDetails?.overnightAddress || {
			line1: '',
			line2: '',
			line3: '',
			line4: '',
			city: '',
			postcode: '',
			country: '',
			county: '',
		}),
	},
	annualMileage: getClosestMileage(
		annualMileageOptions,
		quoteData?.quoteDetails.riskData.vehicleDetails?.annualMileage,
	),
	businessMileage: quoteData?.quoteDetails.riskData.vehicleDetails?.businessMileage?.toString() || '',
	keptOvernight: quoteData?.quoteDetails.riskData.vehicleDetails?.whereParkedOvernight || '',
	overnightAddressIsAway: hasOverNightAddress(
		quoteData?.quoteDetails.riskData.proposerDetails?.address ?? ({} as Address),
		quoteData?.quoteDetails.riskData.vehicleDetails?.overnightAddress ?? ({} as Address),
	)
		? 'yes'
		: 'no',
});
